// to fix file download
export const getDownloadFilename = (contentDisposition, fallbackFilename) => {
  if (!contentDisposition) {
    return fallbackFilename
  }

  const utf8Match = contentDisposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i)
  const standardMatch = contentDisposition.match(/filename\s*=\s*"([^"]+)"|filename\s*=\s*([^;]+)/i)
  const rawFilename = utf8Match?.[1] || standardMatch?.[1] || standardMatch?.[2]

  if (!rawFilename) {
    return fallbackFilename
  }

  const sanitizedFilename = rawFilename.trim().replace(/^"+|"+$/g, '')

  try {
    return decodeURIComponent(sanitizedFilename)
  } catch (error) {
    return sanitizedFilename
  }
}

export const triggerBlobDownload = (blobData, fileName) => {
  const url = window.URL.createObjectURL(new Blob([blobData]))
  const link = document.createElement('a')

  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  link.remove()

  setTimeout(() => {
    window.URL.revokeObjectURL(url)
  }, 0)
}
